module.exports = __webpack_public_path__ + "img/infoSvgIcon.312bb1d8.svg";